import { AfterViewInit, Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MultiPrepSelect } from 'src/app/common/models/multiPrepSelect';
import { FacilityManager } from 'src/app/managers/facility.manager';
import { PrepLocationsService } from 'src/app/services/prep-locations.service';
import { MatCheckbox } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'multi-prep-checklist',
  templateUrl: './multi-prep-checklist.component.html',
  styleUrls: ['./multi-prep-checklist.component.scss'],
  standalone: true,
  imports: [MatCheckbox, FormsModule],
})
export class MultiPrepChecklist implements OnInit, AfterViewInit {
  @Input() public prepLocations: MultiPrepSelect[] = [];
  @Input() public currentPrepLocation!: string;
  @Output() public prepLocationsChange = new EventEmitter<MultiPrepSelect[]>();
  @Output() public validationCheck = new EventEmitter();
  public prepLocationsSelected = 0;
  public dataLoaded = false;
  public selectAll = false;
  public scrollAttemptInterval: number | undefined = undefined;

  constructor(
    private readonly prepService: PrepLocationsService,
    private readonly _facilityManager: FacilityManager,
    private readonly toastr: ToastrService,
  ) {}

  public ngOnInit(): void {
    if (this.prepLocations.length < 1) {
      this.prepService.getPrepLocations(this._facilityManager.getCurrentFacility()).subscribe({
        next: (prepLocations) => {
          for (const pl of prepLocations) {
            this.prepLocations.push({
              prepLocationName: pl.prepLocationTypeName,
              isSelected: pl.prepLocationTypeName === this.currentPrepLocation,
            });
          }
          this.refreshPrepLocationsSelected();
          this.dataLoaded = true;
        },
        error: (e) => this.toastr.error('Unable to load Prep Locations'),
      });
    } else {
      try {
        this.prepLocations = JSON.parse(JSON.stringify(this.prepLocations)) as MultiPrepSelect[];
        this.refreshPrepLocationsSelected();
        this.dataLoaded = true;
      } catch (e) {
        console.error('error parsing preplocs', e);
      }
    }
  }

  public ngAfterViewInit(): void {
    this.scrollAttemptInterval = window.setInterval(() => {
      if (this.dataLoaded) {
        clearInterval(this.scrollAttemptInterval);
        const target = document.getElementById(this.currentPrepLocation);
        if (target) {
          target.scrollIntoView({ block: 'start', behavior: 'smooth' });
        } else {
          console.error(`Scroll attempt failed; could not find element id: ${this.currentPrepLocation}`);
        }
      }
    }, 100);
  }

  public ngOnDestroy(): void {
    clearInterval(this.scrollAttemptInterval);
  }

  public refreshPrepLocationsSelected(): void {
    this.prepLocationsChange.emit(this.prepLocations);
    this.validationCheck.emit();
    this.prepLocationsSelected = this.prepLocations.filter((pl) => {
      return pl.isSelected === true;
    }).length;
  }

  public selectAllPrepLocations(): void {
    this.selectAll = !!this.selectAll;
    this.prepLocations.forEach((pl) => {
      if (pl.prepLocationName !== this.currentPrepLocation) {
        pl.isSelected = this.selectAll;
      }
    });
    this.refreshPrepLocationsSelected();
  }
}
